import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DashboardSmallIcon from "../../_icons/DashboardSmallIcon";
import AlertSmallIcon from "../../_icons/AlertSmallIcon";
import DeviceSmallIcon from "../../_icons/DeviceSmallIcon";
import NoteSmallIcon from "../../_icons/NoteSmallIcon";
import ReportSmallIcon from "../../_icons/ReportSmallIcon";
import _ from "lodash";
import { notesList, sensorList, clearSelectedAlerts, clearSelectedNotes } from "../../_actions";
import { Button } from "react-bootstrap";
import "./index.css";

class FilterMenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disciplineListObj: [],
      notesList: [],
      totalNote: null,
      totalSensor: null,
      reportsPermission: false,
      currentDevicePageType: false
    };
  }

  componentDidMount() {
    this.checkReportsViewPermission(this.props.configList);
    let currentDevicePageType = localStorage.getItem("currentDevicePageType");
    if (currentDevicePageType) {
      currentDevicePageType = JSON.parse(currentDevicePageType);
    }
    if (currentDevicePageType && currentDevicePageType.list !== this.state.currentDevicePageType) {
      this.setState(() => {
        return {
          currentDevicePageType: currentDevicePageType.list
        };
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.configList) !== JSON.stringify(nextProps.configList)) {
      this.checkReportsViewPermission(nextProps.configList);
    }
  }

  onPageChange = () => {
    this.props.clearSelectedAlerts();
    this.props.clearSelectedNotes();
  }

  checkReportsViewPermission = configList => {
    if (
      !configList ||
      configList.permissions.reports === undefined ||
      configList.permissions.reports === null ||
      configList.permissions.reports.length < 1
    ) {
      return null;
    }

    if (
      _.find(configList.permissions.reports, item => {
        return item.can_view_reports === true;
      })
    ) {
      this.setState(() => {
        return {
          reportsPermission: true
        };
      });
    } else {
      this.setState(() => {
        return {
          reportsPermission: false
        };
      });
    }
  };

  renderDeviceBtn = currentPage => {
    if (this.state.currentDevicePageType === true) {
      return (
        <Link className="icon-color" to="/devices" title="Devices page" onClick={this.onPageChange}>
          <Button className={"primaryButton " + (currentPage === "devices" ? "active" : null)} title="Devices list">
            <DeviceSmallIcon className="small-icon" fill="#111111" />
            Devices
          </Button>
        </Link>
      );
    } else {
      return (
        <Link className="icon-color" to="/devicesMap" title="Devices page" onClick={this.onPageChange}>
          <Button className={"primaryButton " + (currentPage === "devices" ? "active" : null)} title="Devices Map">
            <DeviceSmallIcon className="small-icon" fill="#111111" />
            Devices
          </Button>
        </Link>
      );
    }
  };

  render() {
    const { currentPage, notePermission, configList } = this.props;
    const { reportsPermission } = this.state;

    if (!configList && !notePermission) {
      return null;
    }

    return (
      <div className="FilterMenuBar">
        <div className="filterMenuText">
          <Link className="icon-color" to="/" title="Dashboard" onClick={this.onPageChange}>
            <Button className={"primaryButton " + (currentPage === "dashboard" ? "active" : null)} title="Dashboard">
              <DashboardSmallIcon className="small-icon" fill="#111111" />
              Dashboard
            </Button>
          </Link>
          <Link className="icon-color" to="/alerts" title="Alerts page" onClick={this.onPageChange}>
            <Button className={"primaryButton " + (currentPage === "alerts" ? "active" : null)} title="Alerts List">
              <AlertSmallIcon className="small-icon" stroke="#111111" />
              Alerts
            </Button>
          </Link>
          {notePermission ? (
            <Link className="icon-color" to="/notes" title="Notes page" onClick={this.onPageChange}>
              <Button className={"primaryButton " + (currentPage === "notes" ? "active" : null)} title="Notes list">
                <NoteSmallIcon className="small-icon" stroke="#111111" />
                Notes
              </Button>
            </Link>
          ) : null}
          {reportsPermission ? (
            <Link className="icon-color" to="/reports" title="Reports page" onClick={this.onPageChange}>
              <Button className={"primaryButton " + (currentPage === "reports" ? "active" : null)} title="Reports list">
                <ReportSmallIcon className="small-icon" stroke="#111111" />
                Reports
              </Button>
            </Link>
          ) : null}
          {this.renderDeviceBtn(currentPage)}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { notePermission } = state.note;
  const { configList } = state.configuration;
  const { currentPage } = state.header;
  return {
    user,
    currentPage,
    notePermission,
    configList
  };
}

export default connect(
  mapStateToProps,
  {
    notesList,
    sensorList,
    clearSelectedAlerts,
    clearSelectedNotes,
  }
)(FilterMenuBar);



// WEBPACK FOOTER //
// ./src/_components/FilterMenuBar/index.js